<template>
  <div class="main-body">
    <div class="card">
        <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Pending Order <small class="text-muted"> show</small>
                  </h4>
              </div><!--col-->
              <div class="col-sm-7">
                <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                </div><!--btn-toolbar-->
              </div>
          </div><!--row-->
          <div class="row mt-4">
            <div class="col">
                <div class="table-responsive">
                    <table id="salesOrder" class="table table-hover" style="width:100%">
                        <colgroup>
                            <col width="50%">
                            <col width="50%">
                        </colgroup>
                        <tbody>
                            <tr>
                                <td><strong>{{ $t('delivery.label.courier_name') }}: </strong>{{ pendingOrder.courier_name}}</td>
                                <td><strong>{{ $t('delivery.label.reference_no') }}: </strong>{{ pendingOrder.reference_no}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.insurance_value') }}: </strong>{{ pendingOrder.insurance_value}}</td>
                                <td><strong>{{ $t('delivery.label.shipping_code') }}: </strong>{{ pendingOrder.shipping_code}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.email') }}: </strong>{{ pendingOrder.email}}</td>
                                <td><strong>{{ $t('delivery.label.company') }}: </strong>{{ pendingOrder.company}}</td>
                            </tr>
                            <tr>
                                <td colspan="2"><strong>{{ $t('delivery.label.shipment_content') }}: </strong>{{ pendingOrder.shipment_content}}</td>
                             </tr>
                            <tr>
                                <td colspan="2"><strong>{{ $t('delivery.label.address') }}: </strong>{{ pendingOrder.address}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.country') }}: </strong>{{ pendingOrder.country}}</td>
                                <td><strong>{{ $t('delivery.label.district') }}: </strong>{{ pendingOrder.district}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.city') }}: </strong>{{ pendingOrder.city}}</td>
                                <td><strong>{{ $t('delivery.label.state') }}: </strong>{{ pendingOrder.state}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.postal_code') }}: </strong>{{ pendingOrder.postal}}</td>
                                <td><strong>{{ $t('delivery.label.phone') }}: </strong>{{ pendingOrder.phone}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.courier_reference_id') }}: </strong>{{ pendingOrder.courier_reference_id}}</td>
                                <td><strong>{{ $t('delivery.label.number_of_pieces') }}s: </strong>{{ pendingOrder.number_of_pieces}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.declared_value') }}: </strong>{{ pendingOrder.declared_value}}</td>
                                <td><strong>{{ $t('delivery.label.declared_currency') }}: </strong>{{ pendingOrder.declared_currency}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.weight') }}: </strong>{{ pendingOrder.weight}}</td>
                                <td><strong>{{ $t('delivery.label.weight_unit') }}: </strong>{{ pendingOrder.weight_unit}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.height') }}: </strong>{{ pendingOrder.height}}</td>
                                <td><strong>{{ $t('delivery.label.width') }}: </strong>{{ pendingOrder.width}}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('delivery.label.length') }}: </strong>{{ pendingOrder.length}}</td>
                                <td><strong>{{ $t('delivery.label.dimension_uom') }}: </strong>{{ pendingOrder.dimension_uom}}</td>
                            </tr>
                            <tr>
                                <td colspan="2"><strong>{{ $t('delivery.label.remark') }}: </strong>{{ pendingOrder.remark}}</td>
                            </tr>
                            <tr>
                                <td>
                                  <strong>{{ $t('delivery.label.status') }}: </strong>
                                  <span v-html="pendingOrder.status_label"></span>
                                </td>
                                <td><strong>{{ $t('delivery.label.created_at') }}: </strong>{{ pendingOrder.created_at}}</td>
                            </tr>
                            <tr>
                                <td colspan="2"><strong>{{ $t('delivery.label.api_failed_message') }}: </strong>{{ pendingOrder.api_failed_message}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>{{ $t('delivery.label_detail.line_no') }}</th>
                        <th>{{ $t('delivery.label_detail.sku') }}</th>
                        <th>{{ $t('delivery.label_detail.product_name') }}</th>
                        <th>{{ $t('delivery.label_detail.description_export') }}</th>
                        <th>{{ $t('delivery.label_detail.description_import') }}</th>
                        <th>{{ $t('delivery.label_detail.country_of_origin') }}</th>
                        <th>{{ $t('delivery.label_detail.quantity') }}</th>
                        <th>{{ $t('delivery.label.weight') }}</th>
                        <th>{{ $t('delivery.label_detail.item_declared_value') }}</th>
                        <th>{{ $t('delivery.label_detail.hscode') }}</th>
                        <th>{{ $t('delivery.label_detail.hsdescription') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in pendingOrder.items" :key="index">
                        <td>{{ item.line_no }}</td>
                        <td>{{ item.sku }}</td>
                        <td>{{ item.product_name }}</td>
                        <td>{{ item.description_export }}</td>
                        <td>{{ item.description_import }}</td>
                        <td>{{ item.country_of_origin }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.weight }}</td>
                        <td>{{ item.item_declared_value }}</td>
                        <td>{{ item.hscode }}</td>
                        <td>{{ item.hsdescription }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div><!--card-body-->
   </div><!--card-->
  </div>
</template>
<script>
export default {
  name: 'pendingOrderShow',
  mounted () {
    this.axios.get('/delivery/pending/' + this.$route.params.id).then(response => {
      this.pendingOrder = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: [],
      pendingOrder: {
      }
    }
  },
  methods: {

  }
}
</script>
